// extracted by mini-css-extract-plugin
module.exports = {"className":"InputRadio--className","nx-radio":"InputRadio--nx-radio","label":"InputRadio--label"};